<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHinge from "./DesignerQuestionHardwareHinge.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHinge,
            SynsealQuestion,
        ],
    }
</script>
